/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import GenericEditScreen, {
  RowButtons,
  RowContainer,
  RowTitle,
} from 'core/component/GenericEditScreen'
import { Filler } from 'core/screen-util'
import { Avatar } from 'antd'
import { sortWith, ascend } from 'ramda'
import UserGroupModal from './userGroupModal'
import { List } from 'immutable-ext'
import Task from 'data.task'
import { getRoles } from '../../../api/pgads'
import {
  getUsers,
  getUserGroups,
  updateUserGroups,
  deleteUserGroups,
} from '@integec/common-react-screens/lib/auth/auth-api'
import { getApiTargetInfo } from 'core/selectors'
import { ErrorContext } from 'context'

const sortGroups = sortWith([
  ascend(r => (r.toggleable ? r.displayOrderIndex : 999999)),
  ascend(r => r.displayName),
])

const acceptFilter = role => filterText =>
  filterText == null ||
  (role.name || '').toLowerCase().includes(filterText.toLowerCase())

const renderRow = ({ item, style, popModal, onDelete }) => {
  const group = item
  const { name, roles = [], users = [] } = group

  return (
    <RowContainer style={style}>
      <Avatar
        css={{
          backgroundColor: 'white',
          color: users.length === 0 ? 'grey' : 'blue',
          fontSize: '9pt',
          marginLeft: '10px',
          marginRight: '10px',
          minWidth: '60px',
          borderStyle: 'solid',
          borderWidth: '0.5px',
        }}
        shape="square"
        size="small"
      >
        {users.length === 0 ? 'No User' : `${users.length} Users`}
      </Avatar>
      <RowTitle onClick={() => popModal(group)}>
        <b>{name}</b>
        <div css={{ fontSize: '10pt' }}>{`${roles.length} roles`}</div>
      </RowTitle>
      <Filler />

      <RowButtons item={group} onDelete={onDelete} popModal={popModal} />
    </RowContainer>
  )
}

const Groups = ({ apiTargetInfo }) => {
  const [users, setUsers] = useState([])
  const [roles, setRoles] = useState([])
  const { setError } = useContext(ErrorContext)

  useEffect(() => {
    List([getUsers(apiTargetInfo)(), getRoles(apiTargetInfo)()])
      .traverse(Task.of, _ => _)
      .fork(setError, data => {
        setUsers(data.get(0))
        setRoles(data.get(1))
      })
  }, [apiTargetInfo, setError])

  const renderUserGroupModal = ({ hideModal, modalInfo, ...rest }) => (
    <UserGroupModal
      hide={hideModal}
      group={modalInfo}
      {...rest}
      users={users}
      accessRoles={roles}
    />
  )

  return (
    <React.Fragment>
      <GenericEditScreen
        title="Groups"
        loadApiTask={getUserGroups}
        createApiTask={updateUserGroups}
        updateApiTask={updateUserGroups}
        deleteApiTask={deleteUserGroups}
        renderModal={renderUserGroupModal}
        renderRow={renderRow}
        rowHeight={50}
        sort={sortGroups}
        acceptFilter={acceptFilter}
        dataMatcher={d1 => d2 => d1.name === d2.name}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Groups)
